import React from 'react';
import { Bell, User, Menu } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useOps } from '../context/OpsContext';
import './Header.css';

const Header = ({ setIsSidebarOpen, isDesktop }) => {
    const { branches, selectedBranch, setSelectedBranch } = useOps();
    const location = useLocation();

    const getPageTitle = () => {
        const path = location.pathname;
        if (path.includes('dashboard')) return 'Dashboard';
        if (path.includes('leads')) return 'Lead Management';
        if (path.includes('customers')) return 'Customers';
        if (path.includes('packages')) return 'Catalog & Deals';
        if (path.includes('branches')) return 'Branch Network';
        if (path.includes('staff')) return 'Support Staff';
        if (path.includes('instructors')) return 'Instructors';
        if (path.includes('vehicles')) return 'Vehicle Fleet';
        if (path.includes('scheduling')) return 'Scheduling & Diary';
        if (path.includes('settings')) return 'Settings';
        return '';
    };

    return (
        <header className="top-header">
            <div className="header-left">
                {!isDesktop && (
                    <button className="menu-toggle" onClick={() => setIsSidebarOpen(true)}>
                        <Menu size={24} />
                    </button>
                )}
                <h1 className="page-title">{getPageTitle()}</h1>
            </div>

            <div className="header-actions">
                <div className="branch-selector">
                    <span className="branch-label">BRANCH</span>
                    <select
                        className="branch-select"
                        value={selectedBranch}
                        onChange={e => setSelectedBranch(e.target.value)}
                    >
                        <option value="All Branches">All Branches</option>
                        {Array.isArray(branches) && branches.map(b => (
                            <option key={b.id || b.branch_id} value={b.branch_name || b.name}>{b.branch_name || b.name}</option>
                        ))}
                    </select>
                </div>

                <div className="notification-icon">
                    <Bell size={20} />
                    <span className="notification-dot"></span>
                </div>
            </div>
        </header>
    );
};

export default Header;
